import { AppHeader } from "../components/AppHeader";
import { LocationsForm, PasswordForm, ProfileForm } from "../components/AccountForms";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, locations, refresh } = useAuth();
  return (
    <div className="min-h-screen bg-[#EEF1ED]">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-8 sm:py-12 space-y-6">
        <div>
          <p className="label-caps">Settings</p>
          <h1 className="mt-1 font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="account-title">Account</h1>
        </div>
        <ProfileForm key={user.email} user={user} onSaved={refresh} />
        <LocationsForm locations={locations} onSaved={refresh} />
        <PasswordForm />
      </main>
    </div>
  );
}
